import Stack from '@zenbusiness/zui/Stack';
import { superstyled } from '@zenbusiness/zui/styles';

const FieldsetRoot = superstyled({
  name: 'Fieldset',
  slot: 'Root',
  tag: Stack,
  propsAdded: {
    as: 'fieldset'
  },
  styles: {
    border: 'none',
    margin: 0,
    padding: 0
  }
});

function Fieldset({ children, ...delegated }) {
  return <FieldsetRoot {...delegated}>{children}</FieldsetRoot>;
}

export default Fieldset;
